var map = {
	"./image1.jpeg": 375,
	"./image2.jpeg": 594,
	"./image3.jpeg": 225,
	"./image4.jpeg": 996,
	"./image5.jpg": 502,
	"./image6.jpeg": 190,
	"./image7.jpeg": 525,
	"./image8.jpeg": 784,
	"./image9.jpeg": 831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;